export default "__VITE_ASSET__C$FO4Nxo__"